import type { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  UpsellGlpCard,
  UpsellGlpFeaturesSection,
  UpsellGlpRow,
  UpsellGlpText,
  UpsellLandingPage,
} from 'generated/resources/datatable.graphql'

import { GlpCardBlock } from 'modules/discover/components/LandingPageBlocks/GlpCardBlock'
import { GlpHeaderBlock } from 'modules/discover/components/LandingPageBlocks/GlpHeaderBlock'
import { GlpRowBlock } from 'modules/discover/components/LandingPageBlocks/GlpRowBlock'
import { GlpTextBlock } from 'modules/discover/components/LandingPageBlocks/GlpTextBlock'

interface GlpFeaturesSectionBlockProps {
  block: UpsellGlpFeaturesSection
  slug: string
  landingPage: UpsellLandingPage
  currentUpsellOrigin: {
    request_source: string
    request_source_category?: string
    request_source_component?: string
  } | null
}

export const GlpFeaturesSectionBlock: FC<GlpFeaturesSectionBlockProps> = ({
  block,
  slug,
  landingPage,
  currentUpsellOrigin,
}) => {
  if (!block) {
    return null
  }

  return (
    <Box gap="s80">
      {block.header && (
        <GlpHeaderBlock
          block={block.header}
          slug={slug}
          landingPage={landingPage}
          currentUpsellOrigin={currentUpsellOrigin}
        />
      )}
      {block.features && block.features.glpCards && (
        <Box className="grid grid-cols-3 gap-4 " flexDirection="row">
          {block.features.glpCards.map((card: UpsellGlpCard) => (
            <GlpCardBlock block={card} key={card.id} />
          ))}
        </Box>
      )}
      {block.features &&
        block.features.glpRows &&
        block.features.glpRows.map((row: UpsellGlpRow) => (
          <GlpRowBlock
            block={row}
            key={row.id}
            slug={slug}
            landingPage={landingPage}
            currentUpsellOrigin={currentUpsellOrigin}
          />
        ))}
      {block.features && block.features.glpTexts && (
        <Box className="grid grid-cols-3 gap-4" flexDirection="row">
          {block.features.glpTexts.map((text: UpsellGlpText) => (
            <GlpTextBlock block={text} key={text.id} />
          ))}
        </Box>
      )}
    </Box>
  )
}
